import { Instance, SnapshotOut, types } from 'mobx-state-tree';

import { CommonCd } from '../common-cd/CommonCd';

/**
 * # Faq
 *
 * Faq 모델
 */
export const Faq = types
  .model('Faq')
  // --------------------------------------------------------------------------
  .props({
    faqSid: types.number,
    faqTitle: types.string,
    faqConts: types.string,
    faqTypeCd: CommonCd,
    langCd: types.string,
  })
  // --------------------------------------------------------------------------
  // MUTATEs ONLY! - 모델 상태를 변경
  // REQUESTs는 스토어 모델에 작성하세요.
  // ex) yarn gen model faq --store
  .actions((self) => ({
    /*
     * 여러 prop을 한번에 수정
     */
    setProps: (props: { [key: string]: any }) => {
      const newProps = { ...self, ...props } as IFaq;
      (Object.keys(newProps) as TFaqKeys[]).forEach((key) => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        self[key] = newProps[key];
      });
    },
  }));

// --------------------------------------------------------------------------
type TFaq = Instance<typeof Faq>;
type TFaqSnapshot = SnapshotOut<typeof Faq>;

export interface IFaq extends TFaq {}
export type TFaqKeys = keyof TFaqSnapshot & string;
export interface IFaqSnapshot extends TFaqSnapshot {}
export const createFaq = () => types.optional(Faq, {} as TFaq);
